<template>
  <div id="leftTwo" style="height: 100%; width: 105%;"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'HomeLeftTwo',
  props: ['areaId'],
  data(){
    return {
      chart:"",
      interval:null, // 轮询
      // 巡检情况
      GlobalInspectSta:{
        "version": 1,
        "method": "synthScreen.AreaInspectSta",
        "params": {
          "areaId": "0",
        },
        "token": "#",
        "id": 0
      },
      option: {
        color: ['#8977f8'],
        title: {
          text: '逐月巡检统计',
          y: '10px',
          x: '5px',
          textStyle:{
            //文字颜色
            color:'white',
            //字体风格,'normal','italic','oblique'
            fontStyle:'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            // fontWeight:'bold',
            //字体系列
            fontFamily:'黑体',
            //字体大小
            fontSize:18,
            fontWeight: 'bold'
          }
        },
        tooltip : {
          trigger: 'axis',
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // dataZoom: [
        //   {
        //     id: 'dataZoomX',
        //     type: 'slider',
        //     start: 0,
        //     end: 50,
        //   }
        // ],
        xAxis : [
          {
            type : 'category',
            data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#ffffff',
                fontSize: 12,
                fontFamily: '黑体'
              },
            }
          }
        ],
        yAxis : [
          {
            type : 'value',
            minInterval: 1, //设置成1保证坐标轴分割刻度显示成整数。
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ffffff',
                fontSize: 12,
                fontFamily: '黑体'
              }
            }
          }
        ],
        series : [
          {
            name:'巡检数量',
            type:'bar',
            barGap:'80%',/*多个并排柱子设置柱子之间的间距*/
            barCategoryGap:'50%',/*多个并排柱子设置柱子之间的间距*/
            barWidth: '40%',
            data:[10, 52, 200, 334, 390, 330, 220, 340, 360, 240, 210, 231]
          }
        ]
      },
    }
  },
  methods: {
    getGlobalInspectSta(){
      this.GlobalInspectSta.token = this.$store.state.token;
      this.$axios.post(this.$newMainUrl, this.GlobalInspectSta).then(res=> {
        if(res.data.hasOwnProperty('result')){
          this.option.series[0].data = res.data.result.monthInspectNum;
          this.drawChart(this.chart, 'leftTwo', this.option);
        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },

  },
  mounted(){
    this.getGlobalInspectSta();
    this.interval = setInterval(()=>{
      this.getGlobalInspectSta();
    }, 3000)

  },
  destroyed(){
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message: '结束'
    // })
  }
}
</script>

<style scoped>

</style>
